import type { HTMLAttributes } from 'react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { mergeClasses } from '../../../helpers';
import { modalFlexContent } from './modal-flex-content.styles';

type Props = CommonHTMLAttributes &
  Pick<HTMLAttributes<HTMLDivElement>, 'onScroll'> & {
    as?: React.ElementType | React.FC<React.PropsWithChildren<unknown>>;
    children: React.ReactNode;
  };

export const ModalFlexContent = ({ as = 'div', children, className, ...rest }: Props) => {
  const Element = as;
  return (
    <Element className={cx(modalFlexContent, mergeClasses('wv-modal-flex-content', className))} {...rest}>
      {children}
    </Element>
  );
};
